export default __webpack_public_path__ + "static/media/slot-img.b25ac08b.webp";